var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view"},[_c('router-link',{attrs:{"to":"/o-mnie"}},[_c('img',{staticClass:"portrait",attrs:{"src":require("@/assets/images/eryk.jpg"),"alt":""}})]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h2',{staticClass:"title"},[_vm._v("Eryk Andrzejewski")]),_c('p',[_vm._v("Student informatyki i pasjonat programowania")])])
}]

export { render, staticRenderFns }